import context from './context';

export default function subdomain() {
  const [sub] = context.location.hostname.split('.');
  return sub.toLowerCase();
}



// WEBPACK FOOTER //
// ./js/util/subdomain.js